<template>
  <DataList
    title="Одиниці виміру"
    resource="sales-units"
    :columns="columns"
    :get-items-fn="getUnits"
  />
</template>

<script>
import DataList from "../../../components/DataList.vue";
import * as unitsApi from "../../backend/unitsApi.js";

export default {
  components: {
    DataList,
  },
  data: () => ({
    columns: [
      { title: "Найменування", name: "title" },
      { title: "Код", name: "code" },
    ],
  }),
  methods: {
    async getUnits(...args) {
      const entities = await unitsApi.getUnits(args[0], args[1], args[2], args[3]);

      return entities;
    },
  },
};
</script>